import type { BaseCategoryDto } from './models';
import { RestService } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CategoriesLookupService {
  apiName = 'Default';
  

  getCategoryLookup = () =>
    this.restService.request<any, ListResultDto<BaseCategoryDto>>({
      method: 'GET',
      url: '/api/app/categories-lookup/category-lookup',
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
